import { httpClient } from '@/api/httpClient';
import {
  mapApiResourceToClinicContact,
  type ClinicContact,
  type ClinicContactApiResource,
} from './clinicApi.types';

export async function fetchOwnClinicContact(): Promise<ClinicContact> {
  const response = await httpClient.get<ClinicContactApiResource>('/me/clinic');
  return mapApiResourceToClinicContact(response.data);
}
